<template>
    <div class="tips_msg">
      {{ msg }}
    </div>
</template>

<script>
export default {
  name: 'searchBtn',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {

    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .tips_msg{
    width: 100%;
    color: #ee0a24;
    margin-top: 10px;
    font-size: 13px;
  }
</style>
